import { render, staticRenderFns } from "./sopManage.vue?vue&type=template&id=60656871"
import script from "./sopManage.vue?vue&type=script&lang=js"
export * from "./sopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60656871')) {
      api.createRecord('60656871', component.options)
    } else {
      api.reload('60656871', component.options)
    }
    module.hot.accept("./sopManage.vue?vue&type=template&id=60656871", function () {
      api.rerender('60656871', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopManage.vue"
export default component.exports